export enum PaymentMethods {
    SWISH = 'swish',
    TRUSTLY = 'trustly'
}